import i18n from '@/i18n';

export const PREFIX = {
  SUPER_ADMIN: 'super-admin',
  INSPECTOR: 'inspector',
  THIRD_PARTY: 'third-party',
};
export const USER_TYPES = {
  SUPER_ADMIN: 'super_admin',
  INSPECTION_STORE: 'inspection_store',
  THIRD_PARTY: 'third_party',
  END_USER: 'end_user',
};

export const VISIBILITY_LIST = [
  { value: 'public', label: i18n.global.t('constantsList.visibility.public') },
  { value: 'private', label: i18n.global.t('constantsList.visibility.private') },
];

export const ENGINE_TYPES_LIST = [
  { value: 'fuel', label: i18n.global.t('constantsList.engineTypes.fuel') },
  { value: 'electric', label: i18n.global.t('constantsList.engineTypes.electric') },
  { value: 'hybrid', label: i18n.global.t('constantsList.engineTypes.hybrid') },
];
export const COLORS_LIST = [
  { value: 'white', label: i18n.global.t('constantsList.colors.white') },
  { value: 'black', label: i18n.global.t('constantsList.colors.black') },
  { value: 'gray', label: i18n.global.t('constantsList.colors.gray') },
  { value: 'silver', label: i18n.global.t('constantsList.colors.silver') },
  { value: 'red', label: i18n.global.t('constantsList.colors.red') },
  { value: 'blue', label: i18n.global.t('constantsList.colors.blue') },
  { value: 'green', label: i18n.global.t('constantsList.colors.green') },
  { value: 'yellow', label: i18n.global.t('constantsList.colors.yellow') },
  { value: 'orange', label: i18n.global.t('constantsList.colors.orange') },
  { value: 'brown', label: i18n.global.t('constantsList.colors.brown') },
  { value: 'beige', label: i18n.global.t('constantsList.colors.beige') },
  { value: 'pearl_white', label: i18n.global.t('constantsList.colors.pearl_white') },
  { value: 'gunmetal_gray', label: i18n.global.t('constantsList.colors.gunmetal_gray') },
  { value: 'midnight_blue', label: i18n.global.t('constantsList.colors.midnight_blue') },
  { value: 'cherry_red', label: i18n.global.t('constantsList.colors.cherry_red') },
  { value: 'burgundy', label: i18n.global.t('constantsList.colors.burgundy') },
  { value: 'champagne_gold', label: i18n.global.t('constantsList.colors.champagne_gold') },
  { value: 'copper_brown', label: i18n.global.t('constantsList.colors.copper_brown') },
  { value: 'forest_green', label: i18n.global.t('constantsList.colors.forest_green') },
  { value: 'lime_green', label: i18n.global.t('constantsList.colors.lime_green') },
  { value: 'electric_blue', label: i18n.global.t('constantsList.colors.electric_blue') },
  { value: 'matte_black', label: i18n.global.t('constantsList.colors.matte_black') },
  { value: 'carbon_fiber_gray', label: i18n.global.t('constantsList.colors.carbon_fiber_gray') },
  { value: 'neon_yellow', label: i18n.global.t('constantsList.colors.neon_yellow') },
  { value: 'sunburst_orange', label: i18n.global.t('constantsList.colors.sunburst_orange') },
  { value: 'royal_purple', label: i18n.global.t('constantsList.colors.royal_purple') },
  { value: 'rosso_corsa', label: i18n.global.t('constantsList.colors.rosso_corsa') },
  { value: 'obsidian_black', label: i18n.global.t('constantsList.colors.obsidian_black') },
  { value: 'mystic_bronze', label: i18n.global.t('constantsList.colors.mystic_bronze') },
  { value: 'moonlight_silver', label: i18n.global.t('constantsList.colors.moonlight_silver') },
  { value: 'british_racing_green', label: i18n.global.t('constantsList.colors.british_racing_green') },
  { value: 'sapphire_blue', label: i18n.global.t('constantsList.colors.sapphire_blue') },
  { value: 'titanium_gray', label: i18n.global.t('constantsList.colors.titanium_gray') },
  { value: 'amethyst_purple', label: i18n.global.t('constantsList.colors.amethyst_purple') },
  { value: 'frozen_blue', label: i18n.global.t('constantsList.colors.frozen_blue') },
  { value: 'volcanic_orange', label: i18n.global.t('constantsList.colors.volcanic_orange') },
  { value: 'glacier_white', label: i18n.global.t('constantsList.colors.glacier_white') },
  { value: 'neon_teal', label: i18n.global.t('constantsList.colors.neon_teal') },
  { value: 'cyber_gray', label: i18n.global.t('constantsList.colors.cyber_gray') },
  { value: 'aurora_borealis', label: i18n.global.t('constantsList.colors.aurora_borealis') },
  { value: 'midnight_green', label: i18n.global.t('constantsList.colors.midnight_green') },
];

const years = Array.from({ length: new Date().getFullYear() - 1959 }, (_, i) => new Date().getFullYear() - i);
export const YEARS_LIST = years.map((year) => ({ value: year, label: year }));

//#region Promotions
export const PROMOTION_SCOPES_LIST = [
  { value: 'members', label: i18n.global.t('promotions.scopeList.members') },
  { value: 'inspectors', label: i18n.global.t('promotions.scopeList.inspectors') },
];
export const PROMOTION_TYPES_LIST = [
  { value: 'percentage', label: i18n.global.t('promotions.typeList.percentage') },
  { value: 'number', label: i18n.global.t('promotions.typeList.number') },
];
//#endregion Promotions

//#region Packages
export const PACKAGE_TYPES_LIST = [
  { value: USER_TYPES.INSPECTION_STORE, label: i18n.global.t('constantsList.userTypes.inspection_store') },
  { value: USER_TYPES.THIRD_PARTY, label: i18n.global.t('constantsList.userTypes.third_party') },
  { value: USER_TYPES.END_USER, label: i18n.global.t('constantsList.userTypes.end_user') },
];
//#endregion Packages

//#region Tenants
export const TENANT_TYPES_LIST = [
  { value: USER_TYPES.INSPECTION_STORE, label: i18n.global.t('constantsList.userTypes.inspection_store') },
  { value: USER_TYPES.THIRD_PARTY, label: i18n.global.t('constantsList.userTypes.third_party') },
];
//#endregion Tenants

//#region STRUCTURE_CATEGORY
export const STRUCTURE_CATEGORY_TYPES = {
  MEDIA: 'media',
  TITLES: 'titles',
  SUB_CATEGORY: 'sub_category',
};
export const STRUCTURE_CATEGORY_TYPES_LIST = [
  { value: STRUCTURE_CATEGORY_TYPES.MEDIA, label: i18n.global.t('structures.categoryTypes.media') },
  { value: STRUCTURE_CATEGORY_TYPES.TITLES, label: i18n.global.t('structures.categoryTypes.titles') },
  { value: STRUCTURE_CATEGORY_TYPES.SUB_CATEGORY, label: i18n.global.t('structures.categoryTypes.sub_category') },
];

export const STRUCTURE_CATEGORY_MEDIA_TYPES = {
  PICTURES_WITH_DESCRIPTION: 'pictures_with_description',
  INTERACTIVE_PICTURE: 'interactive_picture',
  INSPECTION_MEDIA: 'inspection_media',
  ALL_MEDIA_FROM_POINTS: 'all_media_from_points',
};
export const STRUCTURE_CATEGORY_MEDIA_TYPES_LIST = [
  {
    value: STRUCTURE_CATEGORY_MEDIA_TYPES.PICTURES_WITH_DESCRIPTION,
    label: i18n.global.t('structures.categoryMediaTypes.pictures_with_description'),
  },
  {
    value: STRUCTURE_CATEGORY_MEDIA_TYPES.INTERACTIVE_PICTURE,
    label: i18n.global.t('structures.categoryMediaTypes.interactive_picture'),
  },
  {
    value: STRUCTURE_CATEGORY_MEDIA_TYPES.INSPECTION_MEDIA,
    label: i18n.global.t('structures.categoryMediaTypes.inspection_media'),
  },
  {
    value: STRUCTURE_CATEGORY_MEDIA_TYPES.ALL_MEDIA_FROM_POINTS,
    label: i18n.global.t('structures.categoryMediaTypes.all_media_from_points'),
  },
];

export const STRUCTURE_CATEGORY_TITLES_TYPES = {
  TITLE_AND_INSPECTOR_REPORT_INFO: 'title_and_inspector_report_info',
  TITLE_AND_NOTES: 'title_and_notes',
  POINTS_WITH_DESCRIPTION_AND_MEDIA: 'points_with_description_and_media',
  ALL_NOTES_FROM_POINTS: 'all_notes_from_points',
};
export const STRUCTURE_CATEGORY_TITLES_TYPES_LIST = [
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.TITLE_AND_INSPECTOR_REPORT_INFO,
    label: i18n.global.t('structures.titleTypes.title_and_inspector_report_info'),
  },
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.TITLE_AND_NOTES,
    label: i18n.global.t('structures.titleTypes.title_and_notes'),
  },
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.POINTS_WITH_DESCRIPTION_AND_MEDIA,
    label: i18n.global.t('structures.titleTypes.points_with_description_and_media'),
  },
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.ALL_NOTES_FROM_POINTS,
    label: i18n.global.t('structures.titleTypes.all_notes_from_points'),
  },
];
export const STRUCTURE_CATEGORY_SUBCATEGORY_TYPES_LIST = [
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.TITLE_AND_INSPECTOR_REPORT_INFO,
    label: i18n.global.t('structures.subcategoryTypes.title_and_inspector_report_info'),
  },
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.TITLE_AND_NOTES,
    label: i18n.global.t('structures.subcategoryTypes.title_and_notes'),
  },
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.POINTS_WITH_DESCRIPTION_AND_MEDIA,
    label: i18n.global.t('structures.subcategoryTypes.points_with_description_and_media'),
  },
  {
    value: STRUCTURE_CATEGORY_TITLES_TYPES.ALL_NOTES_FROM_POINTS,
    label: i18n.global.t('structures.subcategoryTypes.all_notes_from_points'),
  },
];
//#endregion STRUCTURE_CATEGORY

//#region VIN_REPORT
export const VIN_REPORT_RESULT_LIST = [
  { value: 'very_good', label: i18n.global.t('vinReports.resultList.very_good') },
  { value: 'good', label: i18n.global.t('vinReports.resultList.good') },
  { value: 'bad', label: i18n.global.t('vinReports.resultList.bad') },
  { value: 'not_available', label: i18n.global.t('vinReports.resultList.not_available') },
];
//#endregion VIN_REPORT
